/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-02-07",
    versionChannel: "nightly",
    buildDate: "2023-02-07T00:21:37.543Z",
    commitHash: "48f4df51a51cc1e2e009b2212eaa14459488a1e4",
};
